module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form-builder-editor-field', _vm._g({
    attrs: {
      "item": _vm.item,
      "show-required": true,
      "show-hide-in-form": true,
      "show-hide-in-reports": true,
      "show-hide-in-preview": true,
      "show-share-with-participant": true,
      "show-is-shared": true
    }
  }, _vm.$listeners), [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "active",
    attrs: {
      "for": _vm.item.name + '-maxsize'
    }
  }, [_vm._v("\n      Maximum number of characters\n    ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.item.maxSize),
      expression: "item.maxSize",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "id": _vm.item.name + '-maxsize',
      "type": "number",
      "min": "0",
      "disabled": !!_vm.item.minSize,
      "oninput": "validity.valid||(value='');"
    },
    domProps: {
      "value": (_vm.item.maxSize)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item, "maxSize", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "active",
    attrs: {
      "for": _vm.item.name + '-maxsize'
    }
  }, [_vm._v("\n      Required number of characters\n    ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.item.minSize),
      expression: "item.minSize",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "id": _vm.item.name + '-minsize',
      "type": "number",
      "min": "0",
      "disabled": !!_vm.item.maxSize,
      "oninput": "validity.valid||(value='');"
    },
    domProps: {
      "value": (_vm.item.minSize)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item, "minSize", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "active",
    attrs: {
      "for": _vm.item.name + '-decimalsize'
    }
  }, [_vm._v("Decimal size")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.item.decimalSize),
      expression: "item.decimalSize",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "id": _vm.item.name + '-decimalsize',
      "type": "number",
      "min": "0",
      "oninput": "validity.valid||(value='');"
    },
    domProps: {
      "value": (_vm.item.decimalSize)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item, "decimalSize", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6955efe6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/formbuilder/editors/FormBuilderEditorNumber.vue
// module id = 1681
// module chunks = 1